import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x",
  "use": "icon-x-usage",
  "viewBox": "0 0 21 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 19\" id=\"icon-x\"><path d=\"M16.675.442h3.056l-6.709 7.639 7.838 10.361h-6.15l-4.816-6.296-5.513 6.296H1.326l7.107-8.17L.927.443H7.23l4.35 5.752L16.676.442ZM15.606 16.65H17.3L6.34 2.169H4.52l11.086 14.48Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol